import { gql, TypedDocumentNode } from '@apollo/client'

import type { Customer } from '../main-types'

export const GET_CUSTOMERS: TypedDocumentNode<{ customer: Customer[] }> = gql`
  query getCustomers {
    customer(order_by: { name: asc }) {
      id
      name
      features
      createdAt: created_at
    }
  }
`
type Params = {
  id: string
  features: Customer['features']
  hasOptionRationale: boolean
}

export const UPDATE_CUSTOMER_FEATURES: TypedDocumentNode<
  { customer: Params & { updatedAt: string } },
  Params
> = gql`
  mutation updateCustomerFeatures($id: uuid!, $features: jsonb!, $hasOptionRationale: Boolean!) {
    customer: update_customer_by_pk(
      pk_columns: { id: $id }
      _set: { has_option_rationale: $hasOptionRationale, features: $features }
    ) {
      features
      hasOptionRationale: has_option_rationale
      updatedAt: updated_at
    }
  }
`
